import * as d3 from "d3";
import $ from 'jquery';
import { addCommas } from './helpers';
import * as axios from 'axios';
import { racecomp } from './groupedracecounty.js'
racecomp()
var Chart = (function () {

    var isMobileIsh,
        showPercentage = false,
        sortOrder = showPercentage ? d3.stackOrderDescending : d3.stackOrderAscending,
        margin = { top: 10, right: 160, bottom: 235, left: 30 },
        width = 1000 - margin.left - margin.right,
        height = 600 - margin.top - margin.bottom,
        svg = d3.select("#raceovertimechart")
            .append("svg")
            .attr('id', 'race-over-time')
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")"),
        g = svg.append('g'),
        segments = g.append('g').attr('class', 'segments'),
        edges = g.append('g').attr('class', 'edges'),
        xAxis = g.append('g').attr('class', 'axis axis--x'),
        yAxis = g.append('g').attr('class', 'axis axis--y'),
        overlay = g.append('rect'),
        focus = g.append('g').attr("class", "focus"),
        segment,
        edge,
        x,
        y,
        color,
        parseDate = d3.timeParse("%Y-%m-%d"),
        area,
        line,
        stack,
        layers = [],
        data = []

    var bisectDate = d3.bisector(function (d) {
        return d.date;
    }).left;

    const pageWidth = window.innerWidth

    const mhData = axios.get("https://docs.google.com/spreadsheets/d/e/2PACX-1vRb8zyDNZXyPrSgwxUxENm2jKPV-ewDJF_CbEGWvCNuYzXZT_6YwCv209lTeyI6tUIL6jRl6ZWD5Dcv/pub?gid=618758641&single=true&output=csv")
        .then(content => {
            const justData = content.data
            const pop = d3.csvParse(justData)

            init(pop)

            const toplevel = d3.csvParse(content.data)

            toplevel.forEach(function (d) {
                d.value = +d.value;
                d.newDate = parseDate(d.date);
            });
            toplevel.sort((a, b) => a.newDate - b.newDate)

            const datalength = toplevel.length

            const currentDate = toplevel[datalength - 1].newDate

            var formatDate = d3.timeFormat("%Y-%m-%d");
            const blackPopCurrentDate = toplevel.filter(d => d.date == formatDate(currentDate) && d.race == "Black")
            const latinXPopCurrentDate = toplevel.filter(d => d.date == formatDate(currentDate) && d.race == "Hispanic")

            const blackPopTotal = d3.nest()
                .rollup(v => d3.sum(v, d => d.value))
                .entries(blackPopCurrentDate);

            const latinXPopTotal = d3.nest()
                .rollup(v => d3.sum(v, d => d.value))
                .entries(latinXPopCurrentDate);

            d3.selectAll('.pop-num-black').append('text').text(addCommas(blackPopTotal))
            d3.selectAll('.pop-num-hispanic').append('text').text(addCommas(latinXPopTotal))

        })
    /**
     * init chart
     */
    function init(pop) {

        d3.selectAll(".genderbuttonb").on("click", function () {

            var selectedVariable = d3.select(this).attr("id");

            if (d3.select(this).classed("selected")) {
            } else {
                d3.selectAll(".genderbuttonb").classed("selected", false);
                d3.select(this).classed("selected", true);
            }
            if (selectedVariable == 'All') { data = pop } else {
                data = pop.filter(function (d) { return d.sex == selectedVariable })
            }
            update(data)
        })

        d3.select(".charttypeRace")
            .on("click", function () {
                type()
            })

        // grab the selected sex and filter data before calling update()
        let data = pop.filter(function (d) { return d.sex == 'Males' })

        function type() {
            showPercentage = !showPercentage;
            sortOrder = showPercentage ? d3.stackOrderDescending : d3.stackOrderReverse;
            if (event) {
                event.target.textContent = showPercentage ? 'Mostrar numero' : 'Mostrar porcentaje';
            }
            update(data);
        }

        // generate initial graph
        update(pop);

    }

    /**
     * Updates stack, layers, segments and layers on datachange
     */
    function update(pop) {

        pop.forEach((d, i) => {
            d.month = parseDate(d.date);
            d.count = +d.value;
        });

        data = d3.nest()
            .key(d => d.date)
            .key(d => d.race)
            .rollup(function (v) {
                return {
                    count: v.length,
                    total: d3.sum(v, function (d) { return d.value; }),
                };
            })
            .entries(pop);

        data.forEach((d) => {
            d.date = parseDate(d.key);
            d['Hispano'] = +d.values[5].value.total;
            d['Afrodescendiente'] = +d.values[2].value.total;
            d['Blanco'] = +d.values[8].value.total;
            d['Todos las otras'] = +d.values[0].value.total;
            d['Chino'] = +d.values[3].value.total;
            d['Filipino'] = +d.values[4].value.total;
            d['Isleños del pacífico'] = +d.values[7].value.total;
            d['Indoamericano'] = +d.values[1].value.total;
            d['Japonés'] = +d.values[6].value.total;
        })

        data.sort((a, b) => a.date - b.date)

        let gender = 'Females';
        let newdata = data.filter(function (d) { return d.sex == gender })

        var keys = d3.keys(data[0]).filter(function (key) { return key !== 'date' && key != 'key' && key != 'values' && key != 'allpop'; })

        stack = d3.stack()
            .keys(keys)
            .order(d3.stackOrderAscending)
            .offset(d3.stackOffsetNone);

        if (showPercentage) {
            stack.offset(d3.stackOffsetExpand);
        }

        layers = stack(data);

        segment = segments.selectAll('path').data(layers);
        segment.enter()
            .append('path')
            .attr('class', 'segment')
            .merge(segment)

        var tooltip = d3.select("body").append("div")
            .attr("class", "tooltip");

        segment.exit().remove();

        edge = edges.selectAll('path').data(layers);
        edge.enter()
            .append('path')
            .attr('class', 'edge')
            .merge(edge)

        edge.exit().remove();

        color = d3.scaleOrdinal()
            .range(["#003F5C", "#B71D93", "#69468E", "#ef4136", "#2b477d", "#4D4E56", "#BCBDBC", "#231f20", "#DAD9D5"])

        render();
    }

    /**
     * render
     */
    function render() {

        setDimensions(window.innerWidth);

        x = d3.scaleTime()
            .domain(d3.extent(data, function (d) { return d.date; }))
            .range([0, width]);

        y = d3.scaleLinear()
            .domain([d3.min(layers, stackMin), d3.max(layers, stackMax)])
            .range([height, 0]);

        area = d3.area()
            .x(d => x(d.data.date))
            .y0(d => y(d[0]))
            .y1(d => y(d[1]))

        line = d3.line()
            .x(d => x(d.data.date))
            .y(d => y(d[0]))

        // draw
        svg.attr('width', (width + margin.left + margin.right))
            .attr('height', (height + margin.top + margin.bottom));

        g.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

        // layers
        segments.selectAll('.segment')
            .transition().duration(850).ease(d3.easeCubicInOut)
            .attr('d', function (d) { return area(d); })
            .attr('fill', function (d) { return color(d.index); });

        edges.selectAll('.edge')
            .transition().duration(850).ease(d3.easeCubicInOut)
            .attr('d', line)
            .attr('stroke', '#fff')
            .attr('stroke-width', 1)
            .attr('fill', 'none')


        xAxis.attr('transform', 'translate(0,' + height + ')')
            .call(d3.axisBottom(x).tickFormat(d3.timeFormat("%b %Y")).ticks(5))
            .select('.tick:last-of-type text')
            .attr('dx', -5)
            .style('text-anchor', 'end');

        var formatPercent = d3.format(".0%");

        if (showPercentage) {
            yAxis
                .call(d3.axisLeft(y).ticks(5).tickFormat(formatPercent))
        } else {
            yAxis
                .call(d3.axisLeft(y).ticks(5))
        }

        var legend = svg.selectAll(".legend")
            .data(stack(data))
            .enter()
            .append("g")
            .attr("class", "legend")
            .attr("transform", "translate(" + (0) + "," + (height + 60) + ")");

        legend.append("rect")
            .attr('x', 40)
            .attr("y", (d, i) => i * 20)
            .attr("width", 10)
            .attr("height", 10)
            .style('fill', d => color(d.key))

        legend.append("text")
            .attr("dx", "1.15em")
            .attr('x', 40)
            .attr("y", (d, i) => (i * 20) + 10)
            .attr('font-family', 'GT Walsheim Regular')
            .attr('font-size', 16)
            .text(d => d.key)

        // tooltips

        var mainTooltip = d3.select("body").append("div")
            .attr("class", "mainTooltip");

        focus
            .style("display", "none");

        focus.append("rect")
            .attr('x', -.5)
            .attr('y', 0)
            .attr('width', 1)
            .attr('height', height)
            .attr('fill', '#ccc')

        overlay
            .attr("class", "overlay")
            .attr("width", width)
            .attr("height", height)
            .on("mouseover", function () {
                focus.style("display", null);
            })
            .on("mouseout", function () {
                focus.style("display", "none");
                mainTooltip.style("visibility", "hidden");
            })
            .on("mousemove", mousemove);

        function mousemove() {
            var main_hover = d3.select('.main-hover')
            main_hover.attr("y", event.pageY - 140 + "px").attr('x', 0)

            var x0 = x.invert(d3.mouse(this)[0]),
                i = bisectDate(data, x0, 1),
                d0 = data[i - 1],
                d1 = data[i],
                d = x0 - d0.date > d1.date - x0 ? d1 : d0;

            var formatTime = d3.timeFormat("%m/%d/%Y");

            focus.attr("transform", "translate(" + x(d.date) + "," + 0 + ")");

            const totalPopulation = d.values[0].value.total + d.values[1].value.total + d.values[2].value.total + d.values[3].value.total + d.values[4].value.total + d.values[5].value.total + d.values[6].value.total + d.values[7].value.total + d.values[8].value.total

            let chinesePercent
            let filipinoPercent
            let pacisPercent
            let aminPercent
            let japanesePercent

            if ((d.values[3].value.total / totalPopulation) * 100 < 1) { chinesePercent = '< 1' } else { chinesePercent = (((d.values[3].value.total / totalPopulation) * 100).toFixed(0)) }
            if ((d.values[4].value.total / totalPopulation) * 100 < 1) { filipinoPercent = '< 1' } else { filipinoPercent = (((d.values[4].value.total / totalPopulation) * 100).toFixed(0)) }
            if ((d.values[7].value.total / totalPopulation) * 100 < 1) { pacisPercent = '< 1' } else { pacisPercent = (((d.values[7].value.total / totalPopulation) * 100).toFixed(0)) }
            if ((d.values[1].value.total / totalPopulation) * 100 < 1) { aminPercent = '< 1' } else { aminPercent = (((d.values[1].value.total / totalPopulation) * 100).toFixed(0)) }
            if ((d.values[6].value.total / totalPopulation) * 100 < 1) { japanesePercent = '< 1' } else { japanesePercent = (((d.values[6].value.total / totalPopulation) * 100).toFixed(0)) }

            const tooltip_str = formatTime(d.date) + '<br/>' +
                "<div class='tooltip-label' style='background:#003f5c;'></div>Hispano: " + addCommas(d.values[5].value.total) + ' (' + (((d.values[5].value.total / totalPopulation) * 100).toFixed(0)) + '%)<br/>' +
                "<div class='tooltip-label' style='background:#b71d93;'></div>Afrodescendiente: " + addCommas(d.values[2].value.total) + ' (' + (((d.values[2].value.total / totalPopulation) * 100).toFixed(0)) + '%)<br/>' +
                "<div class='tooltip-label' style='background:#69468e;'></div>Blanco: " + addCommas(d.values[8].value.total) + ' (' + (((d.values[8].value.total / totalPopulation) * 100).toFixed(0)) + '%)<br/>' +
                "<div class='tooltip-label' style='background:#ef4136;'></div>Todos las otras: " + addCommas(d.values[0].value.total) + ' (' + (((d.values[0].value.total / totalPopulation) * 100).toFixed(0)) + '%)<br/>' +
                "<div class='tooltip-label' style='background:#2b477d;'></div>Chino: " + addCommas(d.values[3].value.total) + ' (' + chinesePercent + '%)<br/>' +
                "<div class='tooltip-label' style='background:#4D4E56;'></div>Filipino: " + addCommas(d.values[4].value.total) + ' (' + filipinoPercent + '%)<br/>' +
                "<div class='tooltip-label' style='background:#BCBDBC;color:#000;'></div>Isleños del pacífico: " + ':' + ' ' + addCommas(d.values[7].value.total) + ' (' + pacisPercent + '%)<br/>' +
                "<div class='tooltip-label' style='background:#231f20;'></div>Indoamericano: " + addCommas(d.values[1].value.total) + ' (' + aminPercent + '%)<br/>' +
                "<div class='tooltip-label' style='background:#DAD9D5;color:#000;'></div>Japonés: " + addCommas(d.values[6].value.total) + ' (' + japanesePercent + '%)'

            mainTooltip
                .style('left', (pageWidth - (width + margin.right + margin.left)) / 2 + margin.left + 30 + x(d.date) + 'px')
                .style("top", event.pageY - 140 + "px").attr('x', 0)
                .html(tooltip_str)
                .style("visibility", "visible")

        }

        //end tooltips

    }

    function toggle(index) {
        update();
    }

    function sortStack() {
        sortOrder = sortOrder === d3.stackOrderInsideOut ? (showPercentage ? d3.stackOrderDescending : d3.stackOrderReverse) : d3.stackOrderInsideOut;
        update();
    }

    function stackMax(layer) {
        return d3.max(layer, function (d) { return d[1]; });
    }

    function stackMin(layer) {
        return d3.min(layer, function (d) { return d[0]; });
    }

    function setDimensions(window) {
        isMobileIsh = window <= 470;
        if (isMobileIsh) {
            margin = { top: 0, right: 20, bottom: 30, left: 30 };
        } else {
            margin = { top: 0, right: 140, bottom: 50, left: 50 };
        }
    }

    return {
        render: render,
        toggle: toggle,
        sortStack: sortStack
    };

})(window);

window.addEventListener('resize', Chart.render);